import api from '..';
import { UF } from './types';
import { useEffect, useState } from 'react';
export const useUFs = () => {
  const [ufs, setUfs] = useState<UF[]>([]);

  useEffect(() => {
    api.get(`/core/ufs/`).then(({ data }) => setUfs(data));
  }, []);

  return { ufs };
};
